// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"0766d07e","413":"2a6da2e5","703":"38afca75","945":"8725a791"}[chunkId] + ".chunk.js";
};